import api from "../apis/api";

class HubspotService {
    saveDomainKey(formData) {
        return api.hubspot.postSaveDomainKey(formData);
    }
}

export default new HubspotService();
